import React from 'react';
import { Helmet } from "react-helmet";
import './style.css';
import Footer from 'components/Footer/Footer';
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import home from 'Assets/home.svg';
import eventsHero from 'Assets/events-hero.png';
import logoCity from 'Assets/logo-city.png';
import EventDetailsBanner from 'components/Banner/EventDetailsBanner';
import facebookLike from 'Assets/facebook.png'
import tweetBtn from 'Assets/twitter.png';
import MoreEventDetails from 'components/MoreEventDetail/MoreEventDetails';
import CommunityPKPlayer from 'components/CommunityPKPlayer/CommunityPKPlayer';
import EventWebinarPlayer from 'components/EventWebinarPlayer/EventWebinarPlayer';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import TitleSection from 'components/TitleBar/TitleSection';
//import Trending from 'components/TrendingNow/Trending';
import PresentationCard from "components/PresentationCard/PresentationCard";
import Organizer from 'components/Organizers/Organizers';
import { browserTimezone, dateConvert, current_unix_stamp, unixDateConversion } from 'utils/Helper';
import { myHeaders_Auth_With_Cache_Control, user_Status_Ver, apiUrl, org_friendly_url, user_access_level, organization_user_access_level, owner_perms, user_Status, user_entity_uuid, events_list_api, myHeaders_Authorized } from 'Api/Api';
// , HeaderConfig, myHeaders_With_Cache_Control
import axios from 'axios';
import { local_routes } from 'utils/Routes';

class EventDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      zoom_join_url: null,
      zoom_registrant_status: null,
      followed: false,
      team_public_event_flag: false,
      event_info: {},
      community_event_presentation_array: [],
      zoom_webinar_event_presentation_array: [],
      show_edit_button: false,
      eventOwner: false,
      eventUuid: '',
      loading: true,
      Events_detail_data: {},
      bannerImgUrlList: [],
      locationImgUrlList: [],
      ticketUrl: null,
      posterImg: null,
      bannerTitle: null,
      eventDetailTitle: null,
      showResults: true,
      presentations: [],
      presenters: [],
      organizers: [],
      venuesDetailData: {},
      locationDetailData: {},
      channelDetailData: {},
      stores: [],
      initialCenter: { lat: 0, lng: 0 },
      showingInfoWindow: false,
      selectedMarkerData: {},
      eventType: null,
      page_title: '',
      eventSource: '' // location / channel / organization
    }
    this.workspace_base_url = "";
    

    if (org_friendly_url) {
      this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
      local_routes.channels = local_routes.teams;
    }
    
  }

    componentDidUpdate (prevProps) {
        let { location: { pathname } } = this.props;

        if (prevProps.location.pathname === pathname) return;
        this.routeChanged();
    }

    routeChanged () {
        this.APICalls();
    }

    componentDidMount() {
        this.routeChanged();
    }

  APICalls = async function () {
    
    let { match: { params: { friendly_url } = {} } = {} } = this.props
    friendly_url = friendly_url.toLowerCase();

    let event_presentations_params = {
      do_recursive: true,
      filter_obj: {
        order_integer: {
          gte: 1
        }
      },
      sort_obj: {
        order_integer: "asc"
      }
    };

    // events_list_detail API Func
    let api_promises = [
      axios.get(events_list_api + "/" + friendly_url + "/locations", myHeaders_Authorized),
      axios.get(events_list_api + "/" + friendly_url + "/channels", myHeaders_Authorized),
      axios.get(events_list_api + "/" + friendly_url + "/venues", myHeaders_Authorized),
      //axios.get(events_list_api + "/" + friendly_url + "/presentations?sort[order_integer]=asc&sort[view_count]=asc", HeaderConfig),
      //axios.get(events_list_api + "/" + friendly_url + "/presentations?do_recursive=true&filter_obj="+encodeURIComponent('{"order_integer":{"gte":1}}')+"&sort_obj="+encodeURIComponent('{"order_integer":"asc"}'), myHeaders_Authorized),
      axios.get(events_list_api + "/" + friendly_url + "/presentations", { params: event_presentations_params, ...myHeaders_Authorized }),
      axios.get(events_list_api + "/" + friendly_url + "/users?sort_obj="+encodeURIComponent('{"presenter_order_integer":"asc"}'), myHeaders_Authorized),
      axios.get(`${events_list_api}/${friendly_url}`, myHeaders_Authorized)
    ];
    
    if (user_Status === 1 && user_Status_Ver === "1") {
      api_promises.push(axios.get(`${apiUrl}users/${user_entity_uuid}/events.audience/${friendly_url}`, myHeaders_Auth_With_Cache_Control));
    }
    
    let [locationRes,channelRes,venueListRes,presentationRes,organizerRes,eventDetailData,audience_result] = await Promise.all(api_promises);
    
    let followed = false;
    let zoom_registrant_status = null;
    let zoom_join_url = null;
    if (audience_result && audience_result.data) {
      if (audience_result.data.favorited_time) {
        followed = true;
      }
      if (audience_result.data.zoom_registrant_status) {
        zoom_registrant_status = audience_result.data.zoom_registrant_status;
        if (zoom_registrant_status === 'approved') {
          if (audience_result.data.zoom_registrant_object && audience_result.data.zoom_registrant_object.join_url) {
            zoom_join_url = audience_result.data.zoom_registrant_object.join_url;
          }
        }
      }
    }
    
    /*
    let [locationRes,channelRes,venueListRes,presentationRes,organizerRes,eventDetailData] = await Promise.all([
      axios.get(events_list_api + "/" + friendly_url + "/locations", myHeaders_Authorized),
      axios.get(events_list_api + "/" + friendly_url + "/channels", myHeaders_Authorized),
      axios.get(events_list_api + "/" + friendly_url + "/venues", myHeaders_Authorized),
      //axios.get(events_list_api + "/" + friendly_url + "/presentations?sort[order_integer]=asc&sort[view_count]=asc", HeaderConfig),
      axios.get(events_list_api + "/" + friendly_url + "/presentations?do_recursive=true&filter_obj="+encodeURIComponent('{"order_integer":{"gte":1}}')+"&sort_obj="+encodeURIComponent('{"order_integer":"asc"}'), myHeaders_Authorized),
      axios.get(events_list_api + "/" + friendly_url + "/users?sort_obj="+encodeURIComponent('{"presenter_order_integer":"asc"}'), myHeaders_Authorized),
      axios.get(`${events_list_api}/${friendly_url}`, myHeaders_Authorized)
    ]);
    */
    
    //const eventDetailData = await axios.get(`${events_list_api}/${friendly_url}`, myHeaders_With_Cache_Control);
    
    //const currentEventUuid = eventDetailData.data.entity_uuid;
    let eventData = eventDetailData.data;
    
    let tmp_team_public_event_flag = false;
    if (!this.workspace_base_url && eventData.organizations_uuid) {
      // team event, but public. don't show 'manage event' button to anyone.
      tmp_team_public_event_flag = true;
    }
    
    let zoom_webinar_event_presentation_array = [];
    zoom_webinar_event_presentation_array = presentationRes.data.filter( element => element.xref_data && element.xref_data.webinar_video_seek_time);
    
    let community_event_presentation_array = [];
    if (eventData.event_type && eventData.event_type === 'community_pk') {
      //let community_event_presentation_response = await axios.get(`${apiUrl}events/${eventData.entity_uuid}/presentations?sort_obj=${encodeURIComponent('{"order_integer":"asc"}')}&filter_obj=${encodeURIComponent('{"order_integer":{"gte":1}}')}`, myHeaders_Authorized);
      //community_event_presentation_array = community_event_presentation_response.data;
      community_event_presentation_array = presentationRes.data;
    }
    
    // JBB - this logic should be here. Also, using .reverse() below is incorrect - it reverses the order of the images displayed in Manage City (which is sorted alpha-numeric)
    let rotating_images = [];
    if (eventData.spotlighted_image_url) {
      rotating_images.push(eventData.spotlighted_image_url);
    }
    if (eventData.image_urls) {
      rotating_images = rotating_images.concat(eventData.image_urls);
    }
    
    // Presentations in the event API call.
    //const presentationRes = await axios.get(events_list_api + "/" + currentEventUuid + "/presentations?sort[order_integer]=asc&sort[view_count]=asc", HeaderConfig);
    
    // filter out pks with visibility_integer === 0
    presentationRes.data = presentationRes.data.filter( element => {
      if (element.xref_data && 'visibility_integer' in element.xref_data) {
        if (element.xref_data.visibility_integer === 0) {
          return false;
        }
      }
      return true;
    });
    
    const pkData = presentationRes.data;

    // Organizers API Func
    //const organizerRes = await axios.get(events_list_api + "/" + currentEventUuid + "/users", HeaderConfig);
    const organizerData = organizerRes.data;
    let presenterTemp = []; let organizerTemp = [];
    let tmp_eventOwner = false;

    organizerData.forEach((item) => {
      if (item.avatar_image_url !== undefined && !null) {
        let url = item.avatar_image_url;
        let array = url.split("/");
        item.avatar_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/noborder_circle_125x125/${array[5]}`
      }
      if (item.xref_data && item.xref_data.presenter_integer) {
        presenterTemp.push(item)
      }
      if (item.xref_data && (item.xref_data.organizer_integer || item.xref_data.entity_owner_integer)) {
        organizerTemp.push(item)
      }
      if (item.entity_uuid === user_entity_uuid && item.xref_data && item.xref_data.entity_owner_integer && item.xref_data.entity_owner_integer >= 1 && user_Status === 1) {
        tmp_eventOwner = true;
      }
      if (item.entity_uuid === user_entity_uuid && item.xref_data && item.xref_data.organizer_integer && item.xref_data.organizer_integer >= 1 && user_Status === 1) {
        tmp_eventOwner = true;
      }
    })

    let locationData = {};
    let channelData = {};
    let venueData = {};
    let tmp_stores = [];
    let tmp_initialCenter = { lat: 0, lng: 0 };
    let tmp_page_title = 'PechaKucha Event: '+eventData.entity_name;
    let eventSource = '';

    if (venueListRes.data.length > 0) {
      eventData.venue_info = venueListRes.data[0];
      venueData = venueListRes.data[0];
      if (venueData.coordinates_lat && venueData.coordinates_lon) {
        let locationLat = venueData.coordinates_lat;
        let locationLon = venueData.coordinates_lon;
        let location_info = {
          entity_name: venueData.entity_name,
          friendly_url: local_routes.cities + '/' + venueData.friendly_url,
          coordinates_lat: venueData.coordinates_lat,
          coordinates_lon: venueData.coordinates_lon,
          next_event: {}
        };
        tmp_stores = [location_info];
        tmp_initialCenter = { lat: locationLat, lng: locationLon };
      }
    }

    // Show edit button?
    let allowed = false;
    if (user_access_level === "admin") {
        // allowed
        allowed = true;
    }
    
    if (organization_user_access_level === "admin") {
        // allowed
        allowed = true;
    }

    if (locationRes.data.length > 0) {
      eventSource = 'location';

      locationData = locationRes.data[0];

      if (owner_perms['locations'] && owner_perms['locations'][locationData.entity_uuid] && owner_perms['locations'][locationData.entity_uuid] === "admin") {
        // allowed
        allowed = true;
      }

      if (locationData.entity_name) {
        tmp_page_title = locationData.entity_name+' '+tmp_page_title;
      }
      if (rotating_images.length === 0) {
        if (locationData.city_skyline_wide_image_url) {
          rotating_images.push(locationData.city_skyline_wide_image_url)
        } else if (locationData.city_skyline_image_url) {
          rotating_images.push(locationData.city_skyline_image_url);
        }
        if (locationData.image_urls) {
          rotating_images = rotating_images.concat(locationData.image_urls);
        }
      }
    }
    
    if (channelRes.data.length > 0) {
      if (!eventSource) {
        eventSource = 'channel';
      }

      channelData = channelRes.data[0];
      
      if (owner_perms['channels'] && owner_perms['channels'][channelData.entity_uuid] && owner_perms['channels'][channelData.entity_uuid] === "admin") {
        // allowed
        allowed = true;
      }
      
      if (channelData.entity_name) {
        tmp_page_title = channelData.entity_name+' '+tmp_page_title;
      }
      if (rotating_images.length === 0) {
        if (channelData.logo_image_url) {
          rotating_images.push(channelData.logo_image_url);
        }
      }
    }

    let tmp_event_type = 'event';
    if (locationData.xref_data && locationData.xref_data.event_type) {
      tmp_event_type = locationData.xref_data.event_type
    }

    // if no venue, use location coords for map
    if (tmp_stores.length === 0 && locationData.entity_name) {
      let location_info = {
        entity_name: locationData.entity_name,
        friendly_url: local_routes.cities + '/' + locationData.friendly_url,
        coordinates_lat: locationData.coordinates_lat,
        coordinates_lon: locationData.coordinates_lon,
        next_event: {}
      };
      tmp_stores = [location_info];
      tmp_initialCenter = { lat: locationData.coordinates_lat, lng: locationData.coordinates_lon };
    }

    eventData.rotating_images = rotating_images;

    let tmp_ticketing_url = null;
    if (eventData.ticketing_url && (current_unix_stamp < (eventData.start_time - 7200))) {
      tmp_ticketing_url = eventData.ticketing_url;
      if (!tmp_ticketing_url.startsWith('https://')) {
        tmp_ticketing_url = 'https://'+tmp_ticketing_url;
      }
    }
    
    let showResults = true; // show details by default
    if (current_unix_stamp > (eventData.end_time + 86400) && pkData.length > 0) {
      // if 24 hours after end, and there are some PKs to show, do not show by default
      showResults = false;
    }
    
    let showJoinMeeting = false;
    if (current_unix_stamp > (eventData.start_time - 7200) && current_unix_stamp < (eventData.end_time + 7200)) {
      showJoinMeeting = true;
    }
    eventData.showJoinMeeting = showJoinMeeting;

    this.setState({
      zoom_webinar_event_presentation_array,
      zoom_registrant_status,
      zoom_join_url,
      followed,
      team_public_event_flag: tmp_team_public_event_flag,
      event_info: eventData,
      community_event_presentation_array,
      show_edit_button: allowed,
      eventUuid: eventDetailData.data.entity_uuid,
      Events_detail_data: eventData,
      //ticketUrl: eventData.ticketing_url && current_unix_stamp < eventData.start_time ? eventData.ticketing_url : null,
      ticketUrl: tmp_ticketing_url,
      posterImg: eventData.poster_image_url,
      eventDetailTitle: eventData.entity_name,
      //bannerTitle: eventData.volume_integer ? `${eventData.locations_text} VOL ${eventData.volume_integer}` : `${eventData.locations_text}`,
      bannerTitle: eventData.volume_integer ? `${eventData.locations_text} VOL ${eventData.volume_integer}` : `${eventData.entity_name}`,
      //bannerImgUrlList: eventData.image_urls && eventData.spotlighted_image_url ? eventData.image_urls.concat(eventData.spotlighted_image_url).reverse() : eventData.image_urls
      bannerImgUrlList: eventData.rotating_images,
      //showResults: pkData.length === 0 ? true : false,
      showResults,
      presentations: pkData,
      presenters: presenterTemp,
      organizers: organizerTemp,
      eventOwner: tmp_eventOwner,
      channelDetailData: channelData,
      locationDetailData: locationData,
      venuesDetailData: venueData,
      //locationImgUrlList: locationData.image_urls && locationData.city_skyline_wide_image_url ? locationData.image_urls.concat(locationData.city_skyline_wide_image_url).reverse() : locationData.image_urls,
      eventType: tmp_event_type,
      page_title:tmp_page_title,
      stores: tmp_stores,
      initialCenter: tmp_initialCenter,
      loading: false,
      eventSource: eventSource
    });

  }

  showAndHideEventDetails = () => {
    this.setState({ showResults: !this.state.showResults });
  }

  render() {
    const { loading, showResults, locationDetailData, channelDetailData, venuesDetailData, ticketUrl, bannerImgUrlList, posterImg, bannerTitle, Events_detail_data, presentations, presenters, organizers } = this.state;
    const { stores, initialCenter, activeMarker, showingInfoWindow, selectedMarkerData, eventType, eventDetailTitle,page_title } = this.state;
    let eventFullDate = null;
    if (selectedMarkerData.startTime) {
      const covertedDate = unixDateConversion(selectedMarkerData.startTime);
      const formattedDate = dateConvert(covertedDate)
      eventFullDate = `${formattedDate.month} ${formattedDate.date},${formattedDate.year}`
    }
    let moreBtnNavigation = "";
    if (locationDetailData.friendly_url) {
      moreBtnNavigation = this.workspace_base_url+local_routes.cities + '/' + locationDetailData.friendly_url;
    } else if (channelDetailData.friendly_url) {
      moreBtnNavigation = this.workspace_base_url+local_routes.channels + '/' + channelDetailData.friendly_url;
      //local_routes.manageevent = local_routes.managechannelevent;
    }
    //let moreBtnNavigation = `${Events_detail_data && Events_detail_data.locations_text && locationDetailData && locationDetailData.friendly_url ? local_routes.cities + '/' + locationDetailData.friendly_url : local_routes.channels + '/' + Events_detail_data.channels_text}`
    let convEventDate = unixDateConversion(Events_detail_data.start_time);
    let formatEventDate = dateConvert(convEventDate)
    let eventStartTime = `${formatEventDate.month} ${formatEventDate.date}, ${formatEventDate.year}`;
    let eventSlot = `${formatEventDate.hour}`
    let convEventEndDate = 0;
    if (Events_detail_data.end_time) {
      convEventEndDate = unixDateConversion(Events_detail_data.end_time);
    } else {
      convEventEndDate = unixDateConversion(Events_detail_data.start_time+7200); // if no end time, fake it for 2 hours after start time
    }
    let formatEventEndDate = dateConvert(convEventEndDate);
    //let browser_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let eventEndSlot = `${formatEventEndDate.hour} (${browserTimezone})`

    if (loading) {
      return (
        <ActivityIndicator theme="spinner" />
      )
    }
    
    let og_image = "";
    if (posterImg) {
      og_image = posterImg;
    } else if (bannerImgUrlList[0]) {
      og_image = bannerImgUrlList[0];
    } else if (logoCity) {
      og_image = logoCity;
    }
    if (og_image) {
      let array = og_image.split("/");
      og_image = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/1200x630/${array[5]}`;
    }
    
    return (
      <div className="main-section event-detail-newpage">
        <Helmet defer={false}>
          <title>{page_title}</title>
          
          <meta name="description" content={this.state.Events_detail_data['description'].replace(/<[^>]+>/g, '')} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@PechaKucha" />
          { this.state.organizers[0] && this.state.organizers[0].twitter_handle &&
              <meta name="twitter:creator" content={`@${this.state.organizers[0].twitter_handle}`} />
          }
          { og_image &&
            <meta property="og:image" content={og_image} />
          }
          <meta property="og:type" content="website" />
          <meta property="og:url" content={window.location.origin+local_routes.events+"/"+this.state.Events_detail_data.friendly_url} />
          <meta property="og:title" content={"PechaKucha Event: "+this.state.Events_detail_data.entity_name} />
          <meta property="og:description" content={this.state.Events_detail_data['description'].replace(/<[^>]+>/g, '')} />
          
        </Helmet>
        {/* Banner section starts */}
        <EventDetailsBanner
          followed={this.state.followed}
          event_info={this.state.event_info}
          eventType={eventType}
          ticketUrl={ticketUrl}
          //carouselImage={(bannerImgUrlList && bannerImgUrlList.length > 0 ? bannerImgUrlList : locationImgUrlList) || []}
          carouselImage={bannerImgUrlList}
          eventHeaderBg={eventsHero}
          posterImg={posterImg}
          headerLogo={logoCity}
          eventName={bannerTitle}
          eventDescription=''
          eventUuid={this.state.eventUuid}
          show_edit_button={this.state.show_edit_button || this.state.eventOwner}
          eventOwner={this.state.eventOwner}
          eventSource={this.state.eventSource}
          edit_event_link={this.workspace_base_url+local_routes.manageevent+'/'+this.state.eventUuid+'/description'}
          team_public_event_flag={this.state.team_public_event_flag}
          referrer={this.workspace_base_url+local_routes.events+'/'+this.state.Events_detail_data.friendly_url}
        />
        {/* Banner section Ends */}

        { (this.state.Events_detail_data.zoom_webinar_video_url) &&
          <div style={{ paddingBottom: "20px" }}>
            <EventWebinarPlayer
              workspace_base_url={this.workspace_base_url}
              presentation_array={this.state.zoom_webinar_event_presentation_array}
              event_info={this.state.Events_detail_data}
            >
            </EventWebinarPlayer>
          </div>
        }

        { (this.state.Events_detail_data.entity_uuid && this.state.community_event_presentation_array.length > 0) &&
          <div style={{ paddingBottom: "20px" }}>
            <CommunityPKPlayer
              workspace_base_url={this.workspace_base_url}
              presentation_array={this.state.community_event_presentation_array}
              event_info={this.state.Events_detail_data}
            >
            </CommunityPKPlayer>
          </div>
        }

        {/* Event Details Section Starts Here */}
        <MoreEventDetails
          zoom_registrant_status={this.state.zoom_registrant_status}
          zoom_join_url={this.state.zoom_join_url}
          event_info={this.state.event_info}
          showResults={showResults}
          showAndHideEventDetails={this.showAndHideEventDetails}
          eventDetailHeading={"Event Details"}
          eventDetailEventName={eventDetailTitle}
          eventDescription={Events_detail_data.description}
          btnText={`More ${Events_detail_data.locations_text ? Events_detail_data.locations_text : Events_detail_data.channels_text} Events`}
          btnNavigation={moreBtnNavigation}
          venueHeading={'Venue'}
          //venueDecription={venuesDetailData.description}
          venueDecription={venuesDetailData.entity_name}
          venueDubDes={venuesDetailData.street}
          dateHeading={'Date'}
          date={eventStartTime}
          time={eventSlot}
          eventEndSlot={eventEndSlot}
          priceHeading={'Pricing'}
          price={Events_detail_data.admission_cost}
          shareHeading={'Share'}
          facebookImg={facebookLike}
          twitterImg={tweetBtn}
          stores={stores}
          initialCenter={initialCenter}
          activeMarker={activeMarker}
          showingInfoWindow={showingInfoWindow}
          selectedMarkerData={selectedMarkerData}
          eventFullDate={eventFullDate}
        />
        {/* Event Details Section Ends Here */}

        {/* Presentaion Section Starts Here */}
        {
          presentations.length > 0 &&
          <div className="container">
            <div className="presentation-section">
              <TitleSection title="Presentations From This event" />
              <div>
                <Row>
                  {
                    presentations.map((item, index) =>
                      <Col key={index} lg={4} sm={12} md={6}>
                        <PresentationCard
                            key={item.entity_uuid}
                            presentation_info={item}
                        />                      
                        {/*
                        <Trending key={index}
                          Trending_now_title={item.entity_name}
                          Trending_now_text={item.description}
                          Trending_img={item.image_url}
                          Trending_link={`${this.workspace_base_url}${local_routes.presentations}/${item.friendly_url}`}
                        />
                        */}
                      </Col>
                    )}
                </Row>
              </div>
            </div>
          </div>
        }
        {/* Presentaion Section Ends Here */}

        {/* Event Speakers Section Starts Here */}
        {
          presenters.length > 0 &&
          <div className="container">
            <div className="presentation-section">
              <TitleSection title="Event Speakers" />
              <div>
                <Row>
                  {
                    presenters.map((item, index) =>
                      <Col key={index} sm={12} md={6} lg={6}>
                        <Organizer show_Icon={false} Organizer_firstname={item.firstname} Organizer_lastname={item.lastname}
                          Organizer_text={item.description} profile_pic={item.avatar_image_url}
                          Organizer_link={
                            (item.friendly_url !== undefined && !null) && (item.status_code === 1) &&
                            `${this.workspace_base_url}${local_routes.users}/${item.friendly_url}`}
                        />
                      </Col>
                    )}
                </Row>
              </div>
            </div>
          </div>
        }
        {/* Event Speakers Section Ends Here */}

        {/* Event Organizers Section Starts Here */}
        {
          organizers.length > 0 &&
          <div className="container">
            <div className="organizers-section">
              <TitleSection title={`Organizers`} />
              <div>
                <Row>
                  {
                    organizers.map((item, index) =>
                      <Col key={index} sm={12} md={6} lg={6}>
                        <Organizer show_Icon={true}
                          twitter_handle={item.twitter_handle}
                          facebook_handle={item.facebook_handle}
                          website_url={item.website_url}
                          youtube_handle={item.youtube_handle}
                          Organizer_firstname={item.firstname}
                          Organizer_lastname={item.lastname}
                          Organizer_text={item.description}
                          profile_pic={item.avatar_image_url}
                          Organizer_link={
                            (item.friendly_url !== undefined && !null) && (item.status_code === 1) &&
                            `${this.workspace_base_url}${local_routes.users}/${item.friendly_url}`}
                        />
                      </Col>
                    )}
                </Row>
              </div>
            </div>
          </div>
        }
        {/* Event Organizers Section Ends Here */}

        {/* Footer section starts here */}
        <Footer
          homeImg={home}
          homeImgRef={this.workspace_base_url ? this.workspace_base_url : "/"}
          breadcrumbMainPage="Events"
          breadcrumbSubPage="Event Detail"
          mainPageLink={`${this.workspace_base_url}/events`} />
        {/* Footer section ends here */}
      </div>
    );

  }
}

export default EventDetails;
